import { object, string, array, number, boolean, SchemaOf } from 'yup';

import { DockerSetupFormValues } from './types';

export const dockerSetupValidationSchema: SchemaOf<DockerSetupFormValues> =
  object({
    name: string()
      .required('Policy name is required')
      .trim()
      .min(1, 'Policy name is required'),
    environmentGroupIds: array(number().required()),
    enableHostManagementFeatures: boolean().required(),
    allowVolumeBrowserForRegularUsers: boolean().required(),
    enableGpuManagement: boolean().required(),
    enableImageNotification: boolean().required(),
    gpus: array(
      object({
        value: string().required(),
        name: string().required(),
      })
    ).required(),
    changeWindow: object({
      Enabled: boolean().required(),
      StartTime: string().required(),
      EndTime: string().required(),
    }).required(),
  });
